import * as localforage from "localforage";
import axios from "axios";
import { successHandling } from "../helpers/successHandling";
import {
  currentDateInUTC,
  scheduledDateInUTC
} from "../helpers/datetimeHandlers";

export const getGroupsApi = async () => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/groups`,
    method: "GET",
    params: {
      company_id,
      group_category_name: "device_control"
    }
  });
  return res.data.groups;
};

export const getDeviceWithTypeApi = async (
  page,
  record,
  group_id,
  company_id,
  tag_id
) => {
  let res = await axios({
    url: `/api/v2/devices/get-data-with-type`,
    method: "POST",
    data: {
      company_id,
      group_id,
      page,
      record,
      tag_id
    }
  });
  return res.data;
};

export const blockWindowsNotifyApi = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  status,
  execute_type,
  execute_datetime,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("status", status.toString());
  formData.append("execute_type", execute_type);
  formData.append("execute_datetime", execute_datetime);
  formData.append("previous_status", !status);

  await axios({
    url: `/api/v2/command/disable-windows-notify-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
export const usbLockApi = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  is_usb_lock,
  execute_type,
  execute_datetime,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("is_usb_lock", is_usb_lock.toString());
  formData.append("execute_type", execute_type);
  formData.append("execute_datetime", execute_datetime);
  formData.append("previous_status", !is_usb_lock);

  await axios({
    url: `/api/v2/command/usb-lock-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const lockCombinationKeyApi = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  status,
  execute_type,
  execute_datetime,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("status", status.toString());
  formData.append("execute_type", execute_type);
  formData.append("execute_datetime", execute_datetime);
  formData.append("previous_status", !status);

  await axios({
    url: `/api/v2/command/combination-key-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const volumeApi = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  status,
  execute_type,
  adjust_number,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("execute_type", execute_type);
  formData.append("adjust_number", adjust_number);
  formData.append("status", status.toString());

  await axios({
    url: `/api/v2/command/volume-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const brightnessApi = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  status,
  execute_type,
  adjust_number,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("execute_type", execute_type);
  formData.append("adjust_number", adjust_number);
  formData.append("status", status.toString());

  await axios({
    url: `/api/v2/command/brightness-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const getScreenshotsApi = async (identity_code, device_id) => {
  const user = await localforage.getItem("user");
  let res = await axios({
    url: `/api/v2/device/screenshots`,
    method: "GET",
    params: {
      user_id: user.id,
      device_id,
      identity_code
    }
  });
  return res.data;
};

export const screenshotsSendApi = async (
  type,
  selectCompany,
  group_id,
  tagId,
  device_ids
) => {
  let formData = new FormData();

  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("type", type);
  formData.append("execute_type", "screenshot");
  let res = await axios({
    url: `/api/v2/command/monitor-screenshot-send`,
    method: "POST",
    data: formData
  });
  return res.data;
};

export const restartSystemAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  execute_type,
  datetime,
  command,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("execute_type", execute_type);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("close_application_command", command);

  await axios({
    url: `/api/v2/command/restart-system-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const kioskModeAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  enableKioskMode,
  enableApplicationAndroid,
  enableApplicationWindows,
  checkedWindows,
  checkedAndroid,
  datetime,
  enableApplication,
  command,
  t,
  successfulText,
  kioskModeSwitchOff,
  osType,
  kiosk_mode
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (osType) formData.append("os_type", osType);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids && device_ids.length) {
    if (device_ids?.length > 0)
      device_ids.map(e => formData.append("device_ids[]", e?.id || e));
  }
  formData.append("execute_type", executeType);
  formData.append("enable_kiosk_mode", enableKioskMode);
  if (enableApplication) {
    formData.append("enable_application", enableApplication);
  }
  if (!kioskModeSwitchOff) {
    if (checkedWindows) {
      formData.append("enable_application_windows", enableApplicationWindows);
    }
    if (checkedAndroid) {
      formData.append("enable_application_android", enableApplicationAndroid);
    } else {
      if (kiosk_mode?.enable_application_android) {
        formData.append("enable_application_android", enableApplicationAndroid);
      }
    }
  }
  if (kiosk_mode && kiosk_mode.enable_application_android !== undefined) {
    delete kiosk_mode.enable_application_android;
  }
  if (kiosk_mode) formData.append("kiosk_mode", JSON.stringify(kiosk_mode));
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("close_application_command", command);

  let res = await axios({
    url: `/api/v2/command/kiosk-mode-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const deviceCmdUpdateAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  updateType,
  datetime,
  is_gray,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("is_gray", is_gray ? 1 : 0);
  formData.append("execute_type", executeType);
  formData.append("update_type", updateType);
  formData.append(
    "execute_datetime",
    updateType === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );

  await axios({
    url: `/api/v2/command/update-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const rotationAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  datetime,
  orientation,
  t,
  successfulText
) => {
  let formData = new FormData();

  formData.append("type", type);

  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id || e));
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("rotation_type", orientation);

  await axios({
    url: `/api/v2/command/screen-rotation-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const vncSettingAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  IsTwoFactorEnable,
  pwd,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("password", pwd);
  formData.append("is_two_factor_enable", IsTwoFactorEnable);

  await axios({
    url: `/api/v2/vnc/security/update-devices`,
    method: "POST",
    data: formData
  });

  successHandling(t, successfulText);
  return true;
};

export const IOSetUpAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  datetime,
  port,
  voltage,
  t,
  successfulText
) => {
  let formData = new FormData();
  let setIOPorts = [];
  if (port.length > 0 && voltage.length > 0) {
    port.forEach((port, i) => {
      setIOPorts.push({ name: port, voltage: voltage[i] });
    });
  } else {
    setIOPorts = [{ name: port, voltage: voltage }];
  }

  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id || e));
  formData.append("set_io_ports", JSON.stringify(setIOPorts));
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  await axios({
    url: `/api/v2/command/io-set-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const deployFileAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  file,
  driveStorageId,
  autoLaunch1,
  autoLaunch2,
  datetime,
  location,
  command,
  selectFileType,
  t,
  successfulText,
  values
) => {
  let formData = new FormData();

  formData.append("type", type);
  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id));
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("file_store_location", location);
  if (selectFileType === "file_from_nubis_drive") {
    formData.append("should_launch_file", autoLaunch2);
    if (autoLaunch2) {
      formData.append("auto_launch_command", command);
    }
    formData.append("drive_storage_id", driveStorageId);
  } else {
    formData.append("should_launch_file", autoLaunch1);
    if (autoLaunch1) {
      formData.append("auto_launch_command", command);
    }
    formData.append("s3_path", file.filePath);
    formData.append("file_md5", file.md5);
  }

  await axios({
    url: `/api/v2/command/deploy-file`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const disableAndriodDeviceOwnerAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  dateType,
  datetime,
  t,
  successfulText
) => {
  let formData = new FormData();

  formData.append("type", type);

  if (type === "company") formData.append("company_id", selectCompany);
  // if (type === "group") formData.append("group_id", group_id);
  // if (type === "tag") formData.append("tag_id", tagId);
  if (type === "group" && group_id.length) {
    group_id.map(e => formData.append("group_ids[]", e));
  }
  if (type === "tag") formData.append("tag_ids[]", tagId);
  if (device_ids?.length > 0)
    device_ids.map(e => formData.append("device_ids[]", e?.id || e));
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    dateType === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );

  await axios({
    url: `/api/v2/command/send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};

export const deviceCMSPlayerAPI = async (
  type,
  selectCompany,
  device_ids,
  group_id,
  tagId,
  executeType,
  enable_mode,
  enable_player,
  t,
  successfulText
) => {
  let formData = {};
  formData.type = type;
  if (type === "company") formData.company_id = selectCompany;
  // if (type === "group") formData.group_id = group_id;
  if (type === "group" && group_id.length) {
    formData.group_ids = group_id;
  }
  if (type === "tag") formData.tag_ids = [tagId];
  if (device_ids?.length > 0)
    formData.device_ids = device_ids.map(e => e.id || e);
  formData.execute_type = executeType;
  formData.enable_mode = enable_mode === "1";
  formData.enable_player = enable_player === "1";

  await axios({
    url: `/api/v2/command/cms_mode`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
